import React, { Fragment, createRef } from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import LiveChat from "./LiveChat";
import Ticket from "./Ticket";
import SelectTicketModal from "./SelectTicketModal";
import chat_png from "../../assets/media/chat.png";
import write_png from "../../assets/media/chatsuite/write.png";
import eco_chat_svg from "../../assets/media/chatsuite/eco_chat.svg";
import user_avatar from "../../assets/media/user.png";
import HexHover from "../../components/HexHover";
import AddNoteModal from "../../components/AddNoteModal";
import SuperTicketDetailModal from "./SuperTicketDetailModal";
import PDFViewerModal from "../../components/PDFViewer";
import "./index.css";

class SuperSupport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatdiv_visible: false,
      supports: [],
      brands: [],
      brand_data: null,
      loadingBrands: false,
      selectedPDF: null,
    };
    this.PDFViewerModalRef = createRef();
  }
  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { role, username } = this.props.location.state;
      this.setState({ username, role, loadingBrands: true });
      //get All brands
      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            const { id } = new_item;
            if (!id) new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        brands.sort(function (a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        if (localStorage.getItem("umbrella")) {
          const umbrellaBrand = Number(localStorage.getItem("umbrella"));
          brands = brands.filter((obj) => obj.parent === umbrellaBrand);
        }
        this.setState({ brands, loadingBrands: false });
      });
      // get All admin support
      Firebase.getAllAdminSupport((res) => {
        if (res) {
          let promises = Object.keys(res).map(async (brand_id) => {
            let result = await Firebase.getAdminSupportById(brand_id);
            let supports = Object.keys(result).map((id) => {
              return {
                id: id,
                ...result[id],
                brand_id,
              };
            });
            return supports;
          });
          Promise.all(promises).then((all_tickets) => {
            let all = [];
            all_tickets.forEach((tickets) => {
              all = all.concat(tickets);
            });
            this.setState({ supports: all });
          });
        }
      });
    }
  }
  showTickets = () => {
    const { super_unreads } = this.props;
    let { supports, brands } = this.state;

    supports.sort((a, b) => {
      if (a.time < b.time) return 1;
      else return -1;
    });

    return supports.map((item, i) => {
      const { brand_id } = item;
      const brand_data = brands.find(
        (brand) => brand.id === parseInt(brand_id, 10)
      );

      const isNew = super_unreads
        .map((unread) => unread.id)
        .includes(brand_id + "_" + item.id);

      return (
        <Fragment key={`${i}-${item.id}`}>
          <Ticket
            isNew={isNew}
            data={item}
            brand_data={brand_data}
            onSelect={() => this.onSelectTicket(item)}
          />
        </Fragment>
      );
    });
  };
  onSelectTicket = (ticket) => {
    const { brands } = this.state;
    const { id, brand_id } = ticket;
    if (id && brand_id) Firebase.readBrandSupportUnReadMessage(brand_id, id);
    this.setState({ chatdiv_visible: false }, () => {
      let brand_data = brands.find((brand) => brand.id === parseInt(brand_id));
      let icon = brand_data.icon;
      this.setState({ ticket, chatdiv_visible: true, brand_data, icon });
    });
  };

  goBack = () => this.props.history.goBack();

  onOpenTicket = async (ticket, brand) => {
    const brand_id = brand.value;
    const type = ticket.value;
    const openedBy = localStorage.getItem("uid");
    const time = new Date().getTime().toString();
    Firebase.createAdminSupport(brand_id, { type, time, openedBy });
  };
  handleClickAttachment = (content) => {
    const { media_type, media_url } = content;
    if (media_type === "pdf_file") {
      this.setState({ selectedPDF: media_url });
      this.PDFViewerModalRef.current.click();
    }
  };
  render() {
    const {
      brand,
      logo,
      chatdiv_visible,
      ticket,
      brand_name,
      icon,
      brand_data,
      loadingBrands,
      brands,
      selectedPDF,
    } = this.state;
    const { username, role } = this.props.location.state;
    const HexButton = HexHover("button", brand_data ? brand_data.hex : "white");

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <div className="second-header">
          <div className="col-md-7 col-lg-7 col-xl-7 heading_pane">
            <img src={eco_chat_svg} height="50" />
            <p>Technical and community management support</p>
            <div className="btn-div">
              <p>New support ticket</p>
              <button data-toggle="modal" data-target="#select_ticket_modal">
                <img src={write_png} width="30" height="30" />
              </button>
            </div>
          </div>
          <div
            className="col-md-5 col-lg-5 col-xl-5 btn-pane"
            style={{ backgroundColor: ticket ? "" : "inherit" }}
          >
            {brand_data && (
              <Fragment>
                <div
                  className="avatar"
                  style={{
                    backgroundImage: `url(${icon || user_avatar})`,
                  }}
                />
                <p>
                  {`${brand_data.name} - `}
                  <span className="ticket-type">{ticket.type}</span>{" "}
                </p>
                {ticket && (
                  <Fragment>
                    <HexButton
                      className="btn btn-light text-dark"
                      data-toggle="modal"
                      data-target="#super_ticket_detail"
                      style={{ marginLeft: "auto" }}
                    >
                      Ticket details
                    </HexButton>
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
        <Fragment>
          <div
            className="row no-gutters flex-md-10-auto"
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              top: 127,
            }}
          >
            <div
              className="col-md-7 col-lg-7 col-xl-7 bg-body-dark"
              style={{ padding: 15, height: "90%", overflow: "scroll" }}
            >
              <div className="content content-full">
                {loadingBrands ? (
                  <div className="loading-spinner">
                    <i className="fa fa-4x fa-sync fa-spin text-muted" />
                    <p>Fetching tickets...</p>
                  </div>
                ) : (
                  <div className="block block-fx-pop">{this.showTickets()}</div>
                )}
              </div>
            </div>
            <div
              className="col-md-5 col-lg-5 col-xl-5"
              style={{ height: "87%" }}
            >
              {chatdiv_visible ? (
                <LiveChat
                  brand={brand_data}
                  ticket={ticket}
                  icon={icon}
                  username={username}
                />
              ) : (
                <div className="empty_chat">
                  <img src={chat_png} alt="chat" />
                  <p>
                    Select a chat ticket or start
                    <br />
                    a new chat, to engage with
                    <br />
                    your community members.
                  </p>
                </div>
              )}
            </div>
          </div>
          <SelectTicketModal onOpenTicket={this.onOpenTicket} brands={brands} />
          {brand_data && (
            <AddNoteModal
              brandData={brand_data}
              uid={localStorage.getItem("uid")}
              ticket={ticket}
              username={username}
              isSuperSupport={true}
            />
          )}
          {ticket && (
            <SuperTicketDetailModal
              ticket={ticket}
              brandData={brand_data}
              onClickAttachment={this.handleClickAttachment}
            />
          )}
          <PDFViewerModal pdfUrl={selectedPDF} />
          <button
            style={{ display: "none" }}
            ref={this.PDFViewerModalRef}
            data-toggle="modal"
            data-target="#view_pdf_dialog"
          />
        </Fragment>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    brand: state.brand,
    super_unreads: state.super_unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SuperSupport);



// WEBPACK FOOTER //
// ./src/screens/SuperSupport/index.js